<template>
  <div class="special-sale-item">
    <div class="banner">
      <img v-lazy="banner" />
    </div>
    <sku-list :sku-list="skuList"></sku-list>
  </div>
</template>

<script>
import SkuList from '../ProductDoubleEach'
export default {
  name: 'productDoubleEach',
  props: {
    skuList: {
      type: Array,
      require: true
    },
    banner: String
  },
  components: {
    SkuList
  }
}
</script>

<style lang="less" scoped>
.banner {
  height: 2.4rem;
  margin-top: 0.1rem;
  background-color: #fff;
  img {
    object-fit: contain;
  }
}
</style>
